const simpli = {
  FORMS: [],
  CSS: {
    id: '62f32ea0fcf4033d189db45a',
    name: 'simpli',
    avatar: {
      name: 'Simpli',
      header: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/nXnhOUvqItyM1660149238988.png',
      new: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/hWloNGLlX9LL1660149172544.png',
      open: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/CnxxSw2tuN7Z1660149224183.png',
      close: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/nXnhOUvqItyM1660149238988.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#0038e3',
        borderColor: '#0038e3'
      }
    }
  }
}

export default simpli
